import { render, staticRenderFns } from "./Judges.vue?vue&type=template&id=6ab4f9a2&"
import script from "./Judges.vue?vue&type=script&lang=js&"
export * from "./Judges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports